import { useState } from 'react';
import { Popover } from '@/components/Popover';
import {
  LabelSelect,
  PillsList,
  ScheduleLabelDataProvider,
} from '@/pages/Schedule/components';
import { useMaybeControlledDisclosure } from '@/pages/Schedule/hooks';
import type { Label, LabelType } from '@/types/gql.generated';
import { EntryModalField } from '../EntryModalField';
import { EntryModalFieldButton } from '../EntryModalFieldButton';

type Props = {
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  labelType: LabelType;
  icon: JSX.Element;
  labels: Label[];
  placeholder: string;
  onChange: (labels: Label[]) => void;
};

export const LabelSheet = ({
  isOpen: controlledIsOpen,
  onOpen: controlledOnOpen,
  onClose: controlledOnClose,
  labelType,
  icon,
  labels,
  placeholder,
  onChange,
}: Props) => {
  const [isAdding, setIsAdding] = useState(false);
  const { isOpen, onOpen, onClose } = useMaybeControlledDisclosure({
    isOpen: controlledIsOpen,
    onOpen: controlledOnOpen,
    onClose: controlledOnClose,
  });

  return (
    <Popover
      isOpen={isOpen}
      trigger={
        <EntryModalField containerProps={{ overflow: 'hidden' }} icon={icon}>
          <EntryModalFieldButton
            placeholder={labels.length ? undefined : placeholder}
            py={labels.length ? 0 : undefined}
            onClick={onOpen}
          >
            <PillsList labels={labels} overflow="hidden" />
          </EntryModalFieldButton>
        </EntryModalField>
      }
      onClose={onClose}
    >
      <ScheduleLabelDataProvider labelType={labelType}>
        <LabelSelect
          isAdding={isAdding}
          selected={labels}
          onAddingChange={setIsAdding}
          onSelect={(label: Label) => onChange([...labels, label])}
          onDeselect={(label: Label) =>
            onChange(labels.filter((item) => item.id !== label.id))
          }
          onUpdate={(label: Label) => {
            const updatedLabels = labels.map((item) => {
              if (item.id === label.id) {
                return label;
              }
              return item;
            });
            onChange(updatedLabels);
          }}
        />
      </ScheduleLabelDataProvider>
    </Popover>
  );
};
